module.exports = __webpack_public_path__ + "img/intro.5e56b6ae.png";